import React from 'react';
import genStyles from './generale.module.css';
import DrawService from '../service/DrawService';


export default function DeleteCollectionForm({ onClose, objectCur, type, setEntites }) {
       
    
    const onValidate = () => {  
        if(type === 'entityForFile'){
            deleteEntityForFileList();
        }else if(type === 'deleteallentityForFile'){
            deleteEntityForFileList();
        }     
    };
   
   const deleteEntityForFileList = () => {      
        // Normaliser : si objectCur est un tableau ou un objet
        const entitiesToDelete = Array.isArray(objectCur) ? objectCur : [objectCur];

        // Supprimer du state React
        setEntites((prev) =>
            prev.filter((item) => !entitiesToDelete.some((obj) => obj.id === item.id))
        );

        // Supprimer du service DrawService
        entitiesToDelete.forEach((entity) => {
            const collection = { id: entity.id };
            DrawService.removeLayerCollection(collection, "entity");           
            DrawService.clearHighlight(entity.id);
        });

        onClose();  
    };

    return (
        <div className="row mb0">
            <div className="col s12 mb20">
                <p className="center-align font_size_22">
                { type === "entityForFile" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> cette entité  ?
                    </>
                )  : type === "deleteallentityForFile" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> les entités sélectionnées ?
                    </>
                ) : null}

                </p>
            </div>
            <div className="col s12">
                <div className={genStyles.buttonfooter}>
                    <button
                    className="btn red lighten-1 z-depth-0 mr5 ml5"
                    style={{ width: '200px' }}
                    onClick={onClose}
                    >
                    Annuler
                    </button>
                    <button
                    className="btn green lighten-1 z-depth-0 mr5 ml5"
                    style={{ width: '200px' }}
                    onClick={onValidate}
                    >
                    Valider
                    </button>
                </div>
            </div>
        </div>
    );
}
